export const CUSTOMER = `CUSTOMER`;
export const INSPECTOR = `INSPECTOR`;